import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconLocationMarker = ({ id, color, width = 11, style, ...restProps }: IProps) => {
  const viewBoxWidth = 11;
  const viewBoxHeight = 16;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M5.5 0C2.5 0 0 2.6 0 5.8c0 1 .3 2.1.8 3l4.3 7c.1.1.3.2.4.2.2 0 .3-.1.4-.2l4.3-7c.5-.9.8-1.9.8-3C11 2.6 8.6 0 5.5 0zm0 8.5c-1.4 0-2.6-1.2-2.6-2.8S4.1 3 5.5 3s2.6 1.2 2.6 2.8S7 8.5 5.5 8.5z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconLocationMarker;
